import {COMMENTS_VIEW_MODE_SEARCH_PARAM, OVERVIEW_COMMENTS_ANCHOR_ID} from '../../helpers/constants'
import {useLocation, useNavigate} from '@github-ui/react-router'
import {useCallback} from 'react'
import {ViewMode} from './utils/view-mode'

export function useScrollToComments() {
  const navigate = useNavigate()
  const {pathname, search} = useLocation()

  return useCallback(() => {
    const nextSearchParams = new URLSearchParams(search)
    nextSearchParams.set(COMMENTS_VIEW_MODE_SEARCH_PARAM, ViewMode.ThreadPreviews)

    navigate(
      {
        pathname,
        search: nextSearchParams.toString(),
        hash: OVERVIEW_COMMENTS_ANCHOR_ID,
      },
      {preventAutofocus: true},
    )
  }, [navigate, pathname, search])
}
